import { useEffect, useState } from "react";

// Counts down from `start` seconds and restarts automatically when it reaches zero.
export function useCountdown(start: number) {
  const [left, setLeft] = useState(start);

  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft((s) => (s <= 1 ? start : s - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [start]);

  const h = Math.floor(left / 3600);
  const m = Math.floor((left % 3600) / 60);
  const s = left % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return { hours: pad(h), minutes: pad(m), seconds: pad(s) };
}
